
import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * create order transaction
 * @param {Number} orderId order id
 * @param {Object} shippingCost shipping cost
  * @param {String} shippingCost.priceType shipping cost
  * @param {Number} shippingCost.qty shipping cost
  * @param {Number} shippingCost.priceUnit shipping cost
  * @param {Number} shippingCost.priceTotal shipping cost
  * @param {String} shippingCost.note shipping cost
 * @param {Array} additionalCost array od additional cost
 */
const createTransaction = async function (shipmentId, shipmentGroupId, shippingCost, additionalCost) {
  try {
    let data = {
      shipmentId,
      shipmentGroupId,
      shippingCost,
      additionalCost,
    }
    let res = await axios.post(urls.transaction, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch transaction list
 * @param {Object} filters list filters
  * @param {Number} filters.page list page
  * @param {Number} filters.size list size
  * @param {String} filters.sort list sorting
  * @param {Number} filters.from list date from
  * @param {Number} filters.to list date to
  * @param {Number} filters.shipperId list filter by shipperId
 */
const transactionList = async function (filters) {
  try {
    let data = {
      ...filters,
      page: filters.page - 1
    }
    let res = await axios.get(urls.transactionList + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch invoice list
 * @param {Object} filters list filters
  * @param {Number} filters.page list page
  * @param {Number} filters.size list size
  * @param {String} filters.sort list sorting
  * @param {Number} filters.from list date from
  * @param {Number} filters.to list date to
  * @param {String} filters.clientType clientType
  * @param {Number} filters.shipperId shipperId
  * @param {Number} filters.transporterId transporterId
  * @param {Array.<String>} filters.status list filter by status
  * @param {String} [filters.invoiceNo] list filter by invoiceNo
 */
const invoiceList = async function (filters) {
  try {
    let data = {
      ...filters,
      page: filters.page - 1
    }
    let res = await axios.get(urls.invoiceList + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create a invoice
 * @param {Array.<Number>} transactions array of transaction Id
 * @param {Number} clientId shipperId
 * @param {Object} additionalInfo invoice additional info
 * @param {Object} additionalInfo.bankAccount invoice bank account additional info
 * @param {String} additionalInfo.bankAccount.bank bank name
 * @param {String} additionalInfo.bankAccount.acc account number
 * @param {String} additionalInfo.bankAccount.att account name
 * @param {String} additionalInfo.signer1_name invoice page signer 1
 * @param {String} additionalInfo.signer1_position invoice page signer 1 position
 * @param {String} additionalInfo.signer2_name invoice page signer 1
 * @param {String} additionalInfo.signer2_position invoice page signer 1 position
 */
const createInvoice = async function (transactions, clientId, additionalInfo) {
  try {
    let data = {
      transactions,
      clientId,
      ...additionalInfo,
      'lastSigner': 0,
      'lastBankAcc': 0,
    }
    let res = await axios.post(urls.invoice, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Fetch transaction list by invoice id
 * @param {Number} invoiceId invoice id to edit
 */
const fetchEditInvoiceTransactionList = async function (invoiceId) {
  try {
    let filter = {
      invoiceId,
    }
    let res = await axios.get(urls.invoiceEditTransactionList + '?' + querystring.stringify(filter))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * update proforma invoice
 * @param {Array} transactions array of edited transactions
 */
const updateInvoice = async function (transactions) {
  try {
    let res = await axios.put(urls.invoiceEditTransactionList, transactions)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * change an invoice status
 * @param {Number} invoiceId invoice id
 * @param {String} status invoice status
 * @param {Number} date date timestamp if updating to RECEIVED or PAID
 */
const invoiceStatus = async function (invoiceId, status, date) {
  try {
    let data = {
      id: invoiceId,
      status
    }
    if (date) data.date = date
    let res = await axios.put(urls.invoiceStatus, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch invoice data for pdf page 1
 * @param {Number} invoiceId invoice id
 */
const invoicePdfData = async function (invoiceId) {
  try {
    let data = {
      id: invoiceId
    }
    let res = await axios.get(urls.invoice + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch invoice detail of transaction list
 * @param {Number} invoiceId Invoice Id
 */
const invoiceDetail1 = async function (invoiceId) {
  try {
    let data = {
      id: invoiceId
    }
    let res = await axios.get(urls.invoiceDetail1 + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch invoice detail of transaction list
 * @param {Number} invoiceId Invoice Id
 */
const invoiceDetail2 = async function (invoiceId) {
  try {
    let data = {
      id: invoiceId
    }
    let res = await axios.get(urls.invoiceDetail2 + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const sendEmail = async function (base64, invoiceId, to) {
  try {
    let data = {
      'to': to,
      'content': 'content',
      'base64Pdf': base64,
      invoiceId,
    }
    console.log('TCL: data', data)
    let res = await axios.post(urls.emailInvoice, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * update common invoice data
 * @param {Object} data invoice common data
 * @param {Object} data.bankAccount bank account details
 * @param {String} data.bankAccount.bank bank name
 * @param {String} data.bankAccount.acc bank account number
 * @param {String} data.bankAccount.att bank account holder name
 * @param {String} data.signer1_name signer 1 name
 * @param {String} data.signer1_position signer 1 position
 * @param {String} data.signer2_name signer 2 name
 * @param {String} data.signer2_position signer 2 Position
 * @param {String} data.imgUrl invoice header image url
 * @param {Number} clientId client is
 */
const invoiceUpdateCommonData = async function (data, clientId) {
  try {
    let reqData = { ...data, clientId }
    let res = await axios.post(urls.invoiceCommonData, reqData)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch client's invoice common data
 * @param {Number} clientId client Id
 */
const fetchInvoiceCommonData = async function (clientId) {
  try {
    let res = await axios.get(urls.invoiceCommonData)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * resubmit invoice to oracle if failed
 * @param {Number} invoiceId invoice id
 */
const resubmitToOracle = async function (invoiceId) {
  try {
    let res = await axios.post(urls.resubmitToOracle, { invoiceId })
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  createTransaction,
  transactionList,
  invoiceList,
  createInvoice,
  invoiceStatus,
  invoicePdfData,
  invoiceDetail1,
  invoiceDetail2,
  sendEmail,
  invoiceUpdateCommonData,
  fetchInvoiceCommonData,
  resubmitToOracle,
  fetchEditInvoiceTransactionList,
  updateInvoice,
}
